{
  "CONVERSATION": {
    "SELECT_A_CONVERSATION": "Pilih percakapan dari panel kiri",
    "CSAT_REPLY_MESSAGE": "Silakan beri peringkat percakapan ini",
    "404": "Maaf, kami tidak dapat menemukan percakapan ini. Silakan coba lagi",
    "SWITCH_VIEW_LAYOUT": "Ganti tampilan",
    "DASHBOARD_APP_TAB_MESSAGES": "Pesan",
    "UNVERIFIED_SESSION": "Identitas pengguna ini belum diverifikasi",
    "NO_MESSAGE_1": "Aduh! Sepertinya tidak ada pesan dari pelanggan di kotak masuk Anda.",
    "NO_MESSAGE_2": " untuk mengirim pesan ke halaman Anda!",
    "NO_INBOX_1": "Halo! Sepertinya Anda belum menambahkan kotak masuk apa pun.",
    "NO_INBOX_2": " untuk memulai",
    "NO_INBOX_AGENT": "Aduh! Sepertinya Anda bukan bagian dari kotak masuk mana pun. Silakan hubungi administrator Anda",
    "SEARCH_MESSAGES": "Mencari pesan dalam percakapan",
    "VIEW_ORIGINAL": "Lihat asli",
    "VIEW_TRANSLATED": "Lihat terjemahan",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Mencari pesan",
      "RESULT_TITLE": "Hasil Pencarian",
      "LOADING_MESSAGE": "Mengolah data...",
      "PLACEHOLDER": "Ketik teks apa saja untuk mencari pesan",
      "NO_MATCHING_RESULTS": "Tidak ada hasil ditemukan."
    },
    "UNREAD_MESSAGES": "Pesan Belum Terbaca",
    "UNREAD_MESSAGE": "Pesan Belum Terbaca",
    "CLICK_HERE": "Klik disini",
    "LOADING_INBOXES": "Memuat kotak masuk",
    "LOADING_CONVERSATIONS": "Memuat Percakapan",
    "CANNOT_REPLY": "Anda tidak dapat membalas karena",
    "24_HOURS_WINDOW": "Pembatasan jendela pesan 24 jam",
    "48_HOURS_WINDOW": "Pembatasan jendela pesan 48 jam",
    "API_HOURS_WINDOW": "You can only reply to this conversation within {hours} hours",
    "NOT_ASSIGNED_TO_YOU": "Percakapan ini tidak ditugaskan kepada Anda. Apakah Anda ingin menugaskan percakapan ini kepada diri Anda?",
    "ASSIGN_TO_ME": "Tugaskan kepada saya",
    "BOT_HANDOFF_MESSAGE": "You are responding to a conversation which is currently handled by an assistant or a bot.",
    "BOT_HANDOFF_ACTION": "Mark open and assign to you",
    "BOT_HANDOFF_REOPEN_ACTION": "Mark conversation open",
    "BOT_HANDOFF_SUCCESS": "Conversation has been handed over to you",
    "BOT_HANDOFF_ERROR": "Failed to take over the conversation. Please try again.",
    "TWILIO_WHATSAPP_CAN_REPLY": "Anda hanya dapat membalas percakapan ini menggunakan pesan template karena",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Pembatasan jendela pesan 24 jam",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "This Instagram account was migrated to the new Instagram channel inbox. All new messages will show up there. You won’t be able to send messages from this conversation anymore.",
    "INSTAGRAM_RESTRICTION_BANNER": "Instagram is currently restricted. Some messages or actions may be delayed or unavailable while we restore full support.",
    "INSTAGRAM_RESTRICTION_STATUS_LINK": "View status update",
    "REPLYING_TO": "Anda membalas:",
    "REMOVE_SELECTION": "Hapus Pilihan",
    "DOWNLOAD": "Unduh",
    "UNKNOWN_FILE_TYPE": "Jenis Berkas Tidak Dikenal",
    "SAVE_CONTACT": "Simpan Kontak",
    "NO_CONTENT": "Tidak ada konten untuk ditampilkan",
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} membagikan sebuah kontak",
      "LOCATION": "{sender} membagikan lokasi",
      "FILE": "{sender} membagikan sebuah berkas",
      "MEETING": "{sender} memulai percakapan"
    },
    "UPLOADING_ATTACHMENTS": "Mengunggah lampiran...",
    "REPLIED_TO_STORY": "Membalas cerita Anda",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "UNSUPPORTED_MESSAGE_TIKTOK": "This message is unsupported. You can view this message on the TikTok app.",
    "UNSUPPORTED_MESSAGE_WHATSAPP": "This message is unsupported. You can view this message on the WhatsApp app.",
    "SUCCESS_DELETE_MESSAGE": "Pesan berhasil dihapus",
    "FAIL_DELETE_MESSSAGE": "Tidak dapat menghapus pesan! Coba lagi",
    "NO_RESPONSE": "Tidak ada respon",
    "RESPONSE": "Response",
    "RATING_TITLE": "Penilaian",
    "FEEDBACK_TITLE": "Umpan Balik",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Tampilkan label",
      "HIDE_LABELS": "Sembunyikan label",
      "LABELS_COUNT": "{count} labels"
    },
    "VOICE_CALL": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NO_ANSWER": "No answer",
      "NO_ANSWER_OUTBOUND_LABEL": "No answer",
      "NO_ANSWER_OUTBOUND_SUBTEXT": "Contact didn't pick up",
      "MISSED_CALL": "Missed call",
      "MISSED_CALL_INBOUND_SUBTEXT": "No agent picked up",
      "MISSED_CALL_DECLINED_BY": "Declined by {agentName}",
      "CALL_ENDED": "Call ended",
      "HANDLED_BY": "Handled by {agentName}",
      "NOT_ANSWERED_YET": "Not answered yet",
      "CALLING": "Calling…",
      "THEY_ANSWERED": "They answered",
      "YOU_ANSWERED": "You answered",
      "AGENT_ANSWERED": "{agentName} answered",
      "JOIN_CALL": "Join call",
      "CALL_BACK": "Call back",
      "TRANSCRIPT_SHOW_MORE": "Show more",
      "TRANSCRIPT_SHOW_LESS": "Show less"
    },
    "HEADER": {
      "RESOLVE_ACTION": "Menyelesaikan",
      "REOPEN_ACTION": "Buka Kembali",
      "OPEN_ACTION": "Terbuka",
      "MORE_ACTIONS": "More actions",
      "OPEN": "Selebihnya",
      "CLOSE": "Tutup",
      "DETAILS": "detail",
      "COPY_ID_SUCCESS": "Conversation ID copied to clipboard",
      "SNOOZED_UNTIL": "Ditunda hingga",
      "SNOOZED_UNTIL_TOMORROW": "Ditunda hingga besok",
      "SNOOZED_UNTIL_NEXT_WEEK": "Ditunda hingga minggu depan",
      "SNOOZED_UNTIL_NEXT_REPLY": "Ditunda hingga balasan selanjutnya",
      "WHATSAPP_CALL": "Start WhatsApp call",
      "WHATSAPP_CALL_FAILED": "Could not start the WhatsApp call.",
      "VOICE_CALL": "Start call",
      "VOICE_CALL_FAILED": "Could not start the call.",
      "WHATSAPP_CALL_PERMISSION_REQUESTED": "Sent a call permission request to the contact. Try again once they accept.",
      "WHATSAPP_CALL_PERMISSION_PENDING": "Call permission request already sent recently. Try again once the contact accepts.",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Tandai sebagai tertunda",
      "SNOOZE_UNTIL": "Tunda",
      "SNOOZE": {
        "TITLE": "Tunda hingga",
        "NEXT_REPLY": "Balasan selanjutnya",
        "TOMORROW": "Besok",
        "NEXT_WEEK": "Minggu depan"
      }
    },
    "MENTION": {
      "AGENTS": "Agen",
      "TEAMS": "Tim"
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Tunda hingga",
      "APPLY": "Tunda",
      "CANCEL": "Batalkan"
    },
    "PRIORITY": {
      "TITLE": "Prioritas",
      "OPTIONS": {
        "NONE": "Tidak ada",
        "URGENT": "Penting",
        "HIGH": "Tinggi",
        "MEDIUM": "Sedang",
        "LOW": "Rendah"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Tidak ada",
        "INPUT_PLACEHOLDER": "Pilih prioritas",
        "NO_RESULTS": "Tidak ada hasil ditemukan",
        "SUCCESSFUL": "Berhasil mengubah prioritas percakapan dengan ID {conversationId} menjadi {priority}",
        "FAILED": "Gagal mengubah prioritas. Silakan coba lagi."
      }
    },
    "DELETE_CONVERSATION": {
      "TITLE": "Delete conversation #{conversationId}",
      "DESCRIPTION": "Are you sure you want to delete this conversation?",
      "CONFIRM": "Hapus"
    },
    "CARD_CONTEXT_MENU": {
      "PENDING": "Tandai sebagai tertunda",
      "RESOLVED": "Tandai sebagai terselesaikan",
      "MARK_AS_UNREAD": "Tandai sebagai belum terbaca",
      "MARK_AS_READ": "Tanda telah dibaca",
      "REOPEN": "Buka kembali percakapan",
      "SNOOZE": {
        "TITLE": "Tunda",
        "NEXT_REPLY": "Hingga balasan berikutnya",
        "TOMORROW": "Hingga besok",
        "NEXT_WEEK": "Hingga minggu depan"
      },
      "ASSIGN_AGENT": "Tugaskan agen",
      "ASSIGN_LABEL": "Tugaskan label",
      "AGENTS_LOADING": "Sedang memuat agen...",
      "ASSIGN_TEAM": "Tugaskan tim",
      "DELETE": "Delete conversation",
      "OPEN_IN_NEW_TAB": "Open in new tab",
      "COPY_LINK": "Copy conversation link",
      "COPY_LINK_SUCCESS": "Conversation link copied to clipboard",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Id percakapan {conversationId} ditugaskan ke \"{agentName}\"",
          "FAILED": "Tidak dapat menugaskan agen. Silakan coba lagi."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Tidak dapat menugaskan label. Silakan coba lagi."
        },
        "LABEL_REMOVAL": {
          "SUCCESFUL": "Removed label #{labelName} from conversation id {conversationId}",
          "FAILED": "Couldn't remove label. Please try again."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Tim \"{team}\" ditugaskan ke id percakapan {conversationId}",
          "FAILED": "Tidak dapat menugaskan tim. Silakan coba lagi."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Tanda tangan pesan",
      "ENABLE_SIGN_TOOLTIP": "Aktifkan tanda tangan",
      "DISABLE_SIGN_TOOLTIP": "Nonaktifkan tanda tangan",
      "MSG_INPUT": "Shift + enter untuk baris baru. Mulailah dengan '/' untuk memilih Canned Response.",
      "PRIVATE_MSG_INPUT": "Shift + enter untuk baris baru. Ini hanya akan terlihat oleh Agen",
      "MESSAGING_RESTRICTED": "You cannot reply to this conversation",
      "MESSAGING_RESTRICTED_WHATSAPP": "You can only reply using a template message due to 24-hour message window restriction",
      "MESSAGING_RESTRICTED_API": "You can only reply using a template message due to message window restriction",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Tanda tangan pesan tidak dikonfigurasi, harap konfigurasikan di pengaturan profil.",
      "COPILOT_MSG_INPUT": "Berikan copilot perintah tambahan, atau tanyakan hal lain... Tekan enter untuk mengirim tindak lanjut",
      "CLICK_HERE": "Klik di sini untuk memperbarui",
      "WHATSAPP_TEMPLATES": "Templat Whatsapp"
    },
    "REPLYBOX": {
      "REPLY": "Balas",
      "PRIVATE_NOTE": "Catatan Pribadi",
      "SEND": "Kirim",
      "CREATE": "Tambahkan Catatan",
      "INSERT_READ_MORE": "Baca lebih lanjut",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "TIP_EMOJI_ICON": "Tampilkan pemilih emoji",
      "TIP_ATTACH_ICON": "Lampirkan file",
      "TIP_AUDIORECORDER_ICON": "Rekam audio",
      "TIP_AUDIORECORDER_PERMISSION": "Izinkan akses ke audio",
      "TIP_AUDIORECORDER_ERROR": "Tidak dapat membuka audio",
      "AUDIO_CONVERSION_FAILED": "Audio conversion failed. Please try again.",
      "DRAG_DROP": "Seret dan letakkan di sini untuk melampirkan",
      "IMAGE_UPLOAD_SUCCESS": "Gambar berhasil diunggah",
      "START_AUDIO_RECORDING": "Mulai merekam audio",
      "STOP_AUDIO_RECORDING": "Berhenti merekam audio",
      "COPILOT_THINKING": "Copilot sedang berpikir",
      "EMAIL_HEAD": {
        "TO": "KEPADA",
        "ADD_BCC": "Tambahkan bcc",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Email dipisahkan dengan koma",
          "ERROR": "Harap masukkan alamat email yang valid"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Email dipisahkan dengan koma",
          "ERROR": "Harap masukkan alamat email yang valid"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Variabel tidak terdefinisi",
        "MESSAGE": "Anda memiliki {undefinedVariablesCount} variabel tidak terdefinisi dalam pesan Anda: {undefinedVariables}. Apakah Anda ingin tetap mengirim pesan ini?",
        "CONFIRM": {
          "YES": "Kirim",
          "CANCEL": "Batalkan"
        }
      },
      "QUOTED_REPLY": {
        "ENABLE_TOOLTIP": "Include quoted email thread",
        "DISABLE_TOOLTIP": "Don't include quoted email thread",
        "REMOVE_PREVIEW": "Remove quoted email thread",
        "COLLAPSE": "Collapse preview",
        "EXPAND": "Expand preview"
      }
    },
    "VISIBLE_TO_AGENTS": "Catatan Pribadi: Hanya terlihat oleh Anda dan tim Anda",
    "CHANGE_STATUS": "Status percakapan berubah",
    "CHANGE_STATUS_FAILED": "Gagal mengubah status percakapan",
    "CHANGE_AGENT": "Percakapan diubah oleh agen",
    "CHANGE_AGENT_FAILED": "Gagal mengubah penugasan",
    "ASSIGN_LABEL_SUCCESFUL": "Label berhasil ditugaskan",
    "ASSIGN_LABEL_FAILED": "Gagal menugaskan label",
    "CHANGE_TEAM": "Percakapan diubah oleh tim",
    "SUCCESS_DELETE_CONVERSATION": "Conversation deleted successfully",
    "FAIL_DELETE_CONVERSATION": "Couldn't delete conversation! Try again",
    "FILE_SIZE_LIMIT": "Lampiran melebihi batas ukuran {MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "FILE_TYPE_NOT_SUPPORTED": "This {fileName} file type is not supported in this conversation",
    "MESSAGE_ERROR": "Tidak dapat mengirim pesan ini, mohon coba lagi nanti",
    "SENT_BY": "Dikirim oleh:",
    "BOT": "Bot",
    "NATIVE_APP": "Native app",
    "NATIVE_APP_ADVISORY": "This message was sent from the native app. Reply from Chatwoot to maintain the message window.",
    "SEND_FAILED": "Tidak dapat mengirim pesan! Coba lagi",
    "TRY_AGAIN": "coba lagi",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Pilih Agen",
      "REMOVE": "Hapus",
      "ASSIGN": "Tugaskan"
    },
    "CONTEXT_MENU": {
      "COPY": "Salin",
      "REPLY_TO": "Balas pesan ini",
      "DELETE": "Hapus",
      "CREATE_A_CANNED_RESPONSE": "Tambahkan ke respon siap pakai",
      "TRANSLATE": "Terjemahkan",
      "COPY_PERMALINK": "Salin tautan ke pesan",
      "LINK_COPIED": "Tautan pesan disalin ke clipboard",
      "DELETE_CONFIRMATION": {
        "TITLE": "Apakah Anda yakin ingin menghapus pesan ini?",
        "MESSAGE": "Anda tidak dapat membatalkan tindakan ini",
        "DELETE": "Hapus",
        "CANCEL": "Batalkan"
      },
      "REPORT_MESSAGE": {
        "LABEL": "Report message",
        "TITLE": "Report Captain message",
        "DESCRIPTION": "Found an issue with this AI response? Let us know what went wrong and our team will review it to help improve Captain's accuracy.",
        "PROBLEM_TYPE": "Problem type",
        "PROBLEM_TYPE_PLACEHOLDER": "Select a problem type",
        "DESCRIPTION_LABEL": "Deskripsi",
        "DESCRIPTION_PLACEHOLDER": "Describe the problem in detail",
        "SUBMIT": "Report",
        "SUCCESS": "Thanks for reporting. Our team will take a look.",
        "ERROR": "Could not report this message. Please try again.",
        "REASONS": {
          "incorrect_information": "Incorrect information",
          "inappropriate_response": "Inappropriate response",
          "incomplete_response": "Incomplete response",
          "outdated_information": "Outdated information",
          "other": "Other"
        }
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontak",
      "COPILOT": "Copilot"
    },
    "VOICE_WIDGET": {
      "INCOMING_CALL": "Incoming call",
      "OUTGOING_CALL": "Outgoing call",
      "CALL_IN_PROGRESS": "Call in progress",
      "NOT_ANSWERED_YET": "Not answered yet",
      "HANDLED_IN_ANOTHER_TAB": "Being handled in another tab",
      "REJECT_CALL": "Reject",
      "DISMISS_CALL": "Tutup",
      "JOIN_CALL": "Join call",
      "END_CALL": "End call",
      "MUTE": "Mute mic",
      "UNMUTE": "Unmute mic",
      "VIEW_CHAT_HISTORY": "View chat history",
      "GO_TO_CONVERSATION": "Go to conversation thread"
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Kirim transkrip percakapan",
    "DESC": "Kirim salinan transkrip percakapan ke alamat email yang ditentukan",
    "SUBMIT": "Kirim",
    "CANCEL": "Batalkan",
    "SEND_EMAIL_SUCCESS": "Transkrip percakapan berhasil terkirim",
    "SEND_EMAIL_ERROR": "Terjadi kesalahan, mohon coba lagi",
    "SEND_EMAIL_PAYMENT_REQUIRED": "Email transcript is not available on your current plan. Please upgrade to use this feature.",
    "FORM": {
      "SEND_TO_CONTACT": "Kirim transkrip ke pelanggan",
      "SEND_TO_AGENT": "Kirim transkrip dari agen yang ditugaskan",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Kirim transkrip ke alamat email lainnya",
      "EMAIL": {
        "PLACEHOLDER": "Masukkan alamat email",
        "ERROR": "Harap masukkan alamat email yang valid"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Hai 👋, Selamat datang di {installationName}!",
    "DESCRIPTION": "Terima kasih telah mendaftar. Kami ingin Anda mendapatkan hasil maksimal dari {installationName}. Berikut beberapa hal yang dapat Anda lakukan di {installationName} untuk membuat pengalaman menyenangkan.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Baca pembaruan terbaru kami",
    "ALL_CONVERSATION": {
      "TITLE": "Semua percakapan Anda di satu tempat",
      "DESCRIPTION": "Lihat semua percakapan dari pelanggan Anda dalam satu dasbor. Anda dapat memfilter percakapan berdasarkan saluran masuk, label, dan status.",
      "NEW_LINK": "Klik di sini untuk membuat kotak masuk"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Undang anggota tim Anda",
      "DESCRIPTION": "Karena Anda bersiap untuk berbicara dengan pelanggan Anda, ajak rekan tim Anda untuk membantu Anda. Anda dapat mengundang rekan tim Anda dengan menambahkan alamat email mereka ke daftar agen.",
      "NEW_LINK": "Klik di sini untuk mengundang anggota tim"
    },
    "LABELS": {
      "TITLE": "Atur percakapan dengan label",
      "DESCRIPTION": "Label memberikan cara yang lebih mudah untuk mengkategorikan percakapan Anda. Buat beberapa label seperti #support-inquiry, #billing-question, dll., Sehingga Anda dapat menggunakannya dalam percakapan nanti.",
      "NEW_LINK": "Klik di sini untuk membuat label"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Agen Ditugaskan",
    "SELF_ASSIGN": "Tugaskan ke saya",
    "TEAM_LABEL": "Tim Ditugaskan",
    "SELECT": {
      "PLACEHOLDER": "Tidak ada"
    },
    "ACCORDION": {
      "CONTACT_DETAILS": "Detail Kontak",
      "CONVERSATION_ACTIONS": "Tindakan Percakapan",
      "CONVERSATION_LABELS": "Label Percakapan",
      "CONVERSATION_INFO": "Informasi Percakapan",
      "CONTACT_NOTES": "Contact Notes",
      "CONTACT_ATTRIBUTES": "Atribut Kontak",
      "PREVIOUS_CONVERSATION": "Percakapan Sebelumnya",
      "MACROS": "Makro",
      "LINEAR_ISSUES": "Linked Linear Issues",
      "SHOPIFY_ORDERS": "Shopify Orders",
      "SHARED_FILES": "Attachments"
    },
    "SHARED_FILES": {
      "EMPTY": "No attachments yet",
      "DOWNLOAD": "Download file",
      "DOWNLOAD_ERROR": "Could not download the file. Please try again.",
      "MEDIA_HEADING": "Media",
      "FILES_HEADING": "Files",
      "VIEW_ALL": "View all",
      "SHOW_LESS": "Show less",
      "MORE_COUNT": "+{count}",
      "UNTITLED_FILE": "Untitled file",
      "JUMP_TO_MESSAGE": "Jump to message"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Ditunda",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Buat atribut",
    "NO_RECORDS_FOUND": "Tidak ditemukan atribut",
    "UPDATE": {
      "SUCCESS": "Atribut berhasil diperbarui",
      "ERROR": "Tidak dapat memperbarui atribut. Silakan coba lagi nanti"
    },
    "ADD": {
      "TITLE": "Tambahkan",
      "SUCCESS": "Atribut berhasil ditambahkan",
      "ERROR": "Tidak dapat membuat atribut. Silakan coba lagi nanti"
    },
    "DELETE": {
      "SUCCESS": "Atribut berhasil dihapus",
      "ERROR": "Tidak dapat menghapus atribut. Silakan coba lagi nanti"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Tambahkan atribut",
      "PLACEHOLDER": "Cari atribut",
      "NO_RESULT": "Tidak ditemukan atribut"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Dari",
    "TO": "Ke",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Subjek",
    "EXPAND": "Expand email"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Berpartisipasi",
    "SIDEBAR_TITLE": "Peserta Percakapan",
    "NO_RECORDS_FOUND": "Tidak ada hasil ditemukan",
    "ADD_PARTICIPANTS": "Pilih peserta",
    "REMANING_PARTICIPANTS_TEXT": "+{count} lainnya",
    "REMANING_PARTICIPANT_TEXT": "+{count} lainnya",
    "TOTAL_PARTICIPANTS_TEXT": "{count} orang berpartisipasi.",
    "TOTAL_PARTICIPANT_TEXT": "{count} orang berpartisipasi.",
    "NO_PARTICIPANTS_TEXT": "Tidak ada yang berpartisipasi!.",
    "WATCH_CONVERSATION": "Gabung dalam percakapan",
    "YOU_ARE_WATCHING": "Anda berpartisipasi",
    "API": {
      "ERROR_MESSAGE": "Tidak dapat memperbarui, coba lagi!",
      "SUCCESS_MESSAGE": "Peserta diperbarui!"
    }
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Lihat konten terjemahan",
    "DESC": "Anda dapat melihat konten terjemahan dalam setiap bahasa.",
    "ORIGINAL_CONTENT": "Konten Asli",
    "TRANSLATED_CONTENT": "Konten Terjemahan",
    "NO_TRANSLATIONS_AVAILABLE": "Tidak ada terjemahan yang tersedia untuk konten ini"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
